<template>
  <div>
    <va-card class="overflow-auto">
      <vue-element-loading :active="visible" :is-full-screen="true" />
      <!-- <div class="listing-section">
          <h3 class="listing-desc-headline margin-top-60 margin-bottom-30">Location</h3>
          <div id="myMap"></div>
      </div>-->
      <div>

        <b-row class="pb-3">
          <b-col cols="6">
 <h4 style="font-size: 24px !important; padding-bottom: 10px">
          CRIME DETAILS
          <span
            v-if="crimeData.isAssigned && appUser.usertype == 0"
            style="color: green; font-size: 14px; font-weight: 600"
            >Assigned</span
          >
        </h4>
          </b-col>
          <b-col class="text-right" cols="6">
               <b-button variant="danger" @click="deleteReport()"
            >Remove Report</b-button
          >
          </b-col>
        </b-row>
        <CrimeCardData
          :crimeData="crimeData"
          :priority="getType(crimeData.priority).name"
        ></CrimeCardData>
        <br />
        <b-row
          class="poppinsbold text-center mr-3"
          align-v="center"
          style="margin-left: 0px; font-size: 14px; height: 40px"
        >
            <b-col
              v-for="item in filteredHeadersList"
              :key="item.value"
              @click="headerSelector = item.value"
              class="vl py-2 poppinsbold"
              :class="headerSelector == item.value ? '' : ''"
              style="font-size: 14px; cursor: pointer; color: white"
              :style="{
                background:
                  headerSelector == item.value ? '#6c757d' : 'whitesmoke',
                color: headerSelector == item.value ? 'white' : '#000000',
              }"
            >
              {{ item.title }}
            </b-col>
          <b-col
            v-if="appUser.usertype == 0"
            :key="pageUpdater + 'assign'"
            @click="assignModal = true"
            md="2"
            style="background-color: whitesmoke; cursor: pointer"
            class="text-black vl py-2 poppinsbold"
          >
            {{ crimeData.isAssigned ? 'RE-ASSIGN' : 'ASSIGN TO' }}
          </b-col>
          <b-modal v-model="assignModal" hide-header hide-footer>
            <b-row class="pa-3">
              <b-col cols="12">
                <span style="font-size: 18px; font-weight: 600">
                  Assign to Analyst
                </span>
              </b-col>
              <b-col cols="12" class="py-3">
                <span>Please select an analyst</span>
                <b-form-select
                  v-model="analystId"
                  value-field="_id"
                  text-field="name"
                  :options="analysts"
                ></b-form-select>
              </b-col>
              <b-col cols="12">
                <b-row>
                  <b-col cols="3">
                    <b-button @click="assign()" variant="success">
                      Submit
                    </b-button>
                  </b-col>
                  <b-col cols="3">
                    <b-button @click="assignModal = false" variant="danger">
                      Cancel
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-modal>

          <!-- <b-col
            v-if="crimeData.allVerified"
            :key="pageUpdater"
            @click="downloadPdf('download')"
            md="3"
            style="background-color: whitesmoke; cursor: pointer"
            class="text-black vl py-2 poppinsbold"
          >
            DOWNLOAD REPORT
          </b-col> -->

          <b-col
            v-if="crimeData.allVerified"
            :key="crimeData.allVerified"
            md="2"
            style="background-color: whitesmoke; cursor: pointer"
            class="text-black vl py-2 poppinsbold"
            v-b-modal.notify
          >
            SEND EMAIL
            <b-modal id="notify" title button-size="sm" centered hide-footer>
              <div class="pb-5">
                <div class="">
                  <label for="tags-basic">SEND REPORT AS EMAIL</label>
                  <b-form-tags
                    placeholder="Type Email ID Here and Press Enter (one by one)..."
                    input-id="tags-basic"
                    v-model="emails"
                  ></b-form-tags>
                </div>
                <div v-if="emails.length > 0" class="pt-3">
                  <b-button
                    width="100%"
                    class="px-2 py-1"
                    variant="info"
                    type="submit"
                    @click="sendEmail('send')"
                    >Send Now</b-button
                  >
                </div>
              </div>
            </b-modal>
          </b-col>
        </b-row>
        <br />
        <b-row v-if="headerSelector == 'extra'">
          <b-col cols="12" md="12">
            <div style="min-height: 45vh" class="mr-1 py-3">
              <ExtraDetails
                :crimeData="crimeData"
                :isStatus="isstatus"
                :key="crimeData._id"
                :priority="getType(crimeData.priority).name"
                @stepper="winStepper"
                :appUser="appUser"
              ></ExtraDetails>

              <Map :location="location" />
            </div>
          </b-col>
        </b-row>
        <b-row v-if="headerSelector == 'analystCheck'">
          <b-col cols="12" md="12">
            <div style="min-height: 70vh" class="mr-1 py-3">
              <CheckBoxData
                :crimeData="crimeData"
                @stepper="winStepper"
                :key="crimeData._id"
              ></CheckBoxData>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="headerSelector == 'airReport'">
          <b-col cols="12" md="12">
            <div style="min-height: 70vh" class="mr-1 py-3">
              <AirReport
                :crimeData="crimeData"
                :appUser="appUser"
                @refresh="getDetails"
              ></AirReport>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="headerSelector == 'operationReport'">
          <b-col cols="12" md="12">
            <div style="min-height: 70vh" class="mr-1 py-3">
              <OperationReport
                :crimeData="crimeData"
                :appUser="appUser"
                @refresh="getDetails"
              ></OperationReport>
            </div>
          </b-col>
        </b-row>
      </div>
    </va-card>
  </div>
</template>

<script>
import axios from 'axios'
import CrimeCardData from './crimeCardData'
import VueElementLoading from 'vue-element-loading'
import ExtraDetails from './extraDetails'
import CheckBoxData from './checkBoxData'
import AirReport from './AirReport'
import OperationReport from './OperationReport'
import Map from './map'

export default {
  components: {
    VueElementLoading,
    CrimeCardData,
    ExtraDetails,
    CheckBoxData,
    AirReport,
    OperationReport,
    Map,
  },
  props: ['id'],
  data () {
    return {
      emails: [],
      msg: '',
      visible: false,
      perPage: '10',
      currentPage: 1,
      data: [],
      isstatus: false,
      location: [],
      err: '',
      crimeVerification: {
        reliable: false,
        accurate: false,
        timeBound: false,
        actionable: false,
      },
      crimeData: {},
      analystNotes: [],
      analysts: [],
      analystId: null,
      assignModal: false,

      headersList: [
        {
          title: 'MORE DETAILS',
          value: 'extra',
          md: '2',
          ismore: false,
          type: false,
        },
        {
          title: 'ANALYST VERIFICATION',
          value: 'analystCheck',
          md: '3',
          ismore: false,
          type: false,
        },
      ],
      priorities: [
        {
          name: 'Low',
          value: 0,
        },
        {
          name: 'Medium',
          value: 1,
        },
        {
          name: 'High',
          value: 2,
        },
      ],
      headerSelector: 'extra',
      pageUpdater: 0,
    }
  },
  computed: {
    appUser () {
      if (this.$store.state.userData) return this.$store.state.userData
      else return {}
    },
    filteredHeadersList () {
      let headers = [
        {
          title: 'MORE DETAILS',
          value: 'extra',
        },
        {
          title: 'ANALYST VERIFICATION',
          value: 'analystCheck',
        },
      ]
      if (this.crimeData.isAssigned) {
        headers.push({
          title: 'AIR REPORT',
          value: 'airReport',
        })
      }
      if ((this.crimeData.isAirSubmitted || this.crimeData.isAirApproved) && this.crimeData.status === 'solved') {
        headers.push({
          title: 'OPERATION REPORT',
          value: 'operationReport',
        })
      }
      return headers
    },
  },

  mounted: function () {
    this.getDetails()
    this.analystList()

    // console.log(this.player);
  },
  methods: {
    winStepper (windowData) {
      if (windowData.response.status) {
        this.getDetails()
      } else alert(windowData.response.msg)
    },
    getType (item) {
      var priority = this.priorities.find((priorityItem) => {
        return priorityItem.value == item
      })
      return priority
    },
    deleteReport () {
      if (confirm('Are you sure?')) {
        this.visible = true
        axios({
          method: 'POST',

          headers: {
            token: localStorage.getItem('token'),
          },
          url: '/admin/crimereport/delete/' + this.id,
        })
          .then((response) => {
            this.visible = false
            if (response.data.status) {
              this.msg = response.data.msg
              this.$dlg.alert(this.msg, () => {}, { messageType: 'success' })
              // window.close()
              this.$router.push('/reportslist/nodata')
              //  this.$router.go(-1);
            } else {
              this.msg = response.data.msg
              this.$dlg.alert(this.msg, () => {}, { messageType: 'error' })
            }
          })
          .catch((err) => {
            this.visible = false
            this.errors.push(err)
            this.$dlg.alert(
              this.msg,
              () => {
                // this.$router.push("/Dashboard");
              },
              { messageType: 'error' }
            )
          })
      } else {
        this.visible = false
        this.$router.go(-1)
      }
    },
    analystList () {
      axios({
        method: 'POST',
        url: '/admin/list',
        headers: {
          token: localStorage.getItem('token'),
        },
      })
        .then((response) => {
          this.analysts = response.data.data
        })

        .catch((err) => {
          console.log(err)
        })
    },
    sendEmail (type) {
      var data = {}
      data['CRid'] = this.crimeData.crimeReportID
      if (this.emails.length > 0) data['emailids'] = this.emails
      data['pdfType'] = type
      axios({
        method: 'POST',
        url: '/pdf/generate/CR_Details',
        headers: {
          token: localStorage.getItem('token'),
        },
        data: data,
      })
        .then((response) => {
          if (response.data.status) {
            console.log(type), 'em'

            this.emails = []
            this.getDetails()
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    downloadPdf (type) {
      var data = {}
      data['CRid'] = this.crimeData.crimeReportID
      data['pdfType'] = type
      axios({
        method: 'POST',
        url: '/pdf/generate/CR_Details',
        headers: {
          token: localStorage.getItem('token'),
        },
        data: data,
        responseType: 'blob',
      })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]))
          var link = document.createElement('a')
          link.href = fileURL
          link.download = 'crimeReport.pdf'
          link.dispatchEvent(new MouseEvent('click'))
        })
        .catch((err) => {
          console.log(err)
        })
    },

    getDetails () {
      this.visible = true
      axios({
        method: 'POST',
        url: '/crimereports/view/details/' + this.id,
        headers: {
          token: localStorage.getItem('token'),
        },
      })
        .then((response) => {
          this.isstatus = response.data.status
          if (response.data.status) {
            this.location = response.data.data.location
            this.pageUpdater += 1
            this.crimeData = response.data.data

            this.data = response.data.data
            var vm = this
            Object.keys(vm.data.verificationStatus).forEach(function (key) {
              if (vm.data.verificationStatus[key] == 'yes') {
                vm.crimeVerification[key] = true
              } else if (vm.data.verificationStatus[key] == 'no') {
                vm.crimeVerification[key] = false
              }
            })
            this.visible = false
          } else {
            this.visible = false
          }
        })
        .catch((err) => {
          console.log(err)
          this.visible = false
          // this.errors.push(err);
          this.msg = 'failed'
        })
    },
    assign () {
      this.visible = true
      var data = {}
      data['id'] = this.id
      data['analystId'] = this.analystId
      axios({
        method: 'POST',
        headers: {
          token: localStorage.getItem('token'),
        },
        url: '/crimereport/assign/analyst',
        data: data,
      })
        .then((response) => {
          if (response.data.status) {
            this.visible = false
            this.getDetails()

            this.assignModal = false
            this.$dlg.alert((this.msg = response.data.msg), () => {}, {
              messageType: 'success',
            })
          } else {
            this.assignModal = false
            this.visible = false

            this.$dlg.alert((this.msg = response.data.msg), () => {}, {
              messageType: 'error',
            })
          }
        })
        .catch((e) => {
          console.log(e)
          this.visible = false
        })
    },
  },
}
</script>
<style>
@import "../../assets/style/listing-style0.css";
.bg-clr {
  background-color: #c1c1c1;
}

.class1 {
  margin-bottom: 2rem !important;
  /* margin-top: 0rem;  */
}
.card {
  box-shadow: none !important;
}
.vl {
  border-left: 0.1px solid rgb(236, 233, 233);
  height: 100%;
}
.vl {
  border-right: 0.1px solid rgb(236, 233, 233);
  height: 100%;
}
.cntr {
  text-align: center;
}

.borderClass {
  border-block-end: 3px solid #6c757d;
  /* border-block-: 3px solid #6c757d; */
}
.hoveractive:hover {
  color: #6c757d;
  background-color: #ececec;
}
</style>
